import { IState } from '../../store';

export const getAgentAvailability = (state: IState) => state.offerData.agentAvailability;
